const translations = {
    myAccount: 'My Account',
    subscription: 'Subscription',
    users: 'Users'
};

export default translations;
